// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"270":"31d6cfe0","384":"03f471ae","664":"0f3ae155","701":"03f471ae","947":"03f471ae"}[chunkId] + ".chunk.css";
};